// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as ReactIf from "react-if";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as NavSDK$Showside from "../utils/NavSDK.bs.js";
import * as PDPForm$Showside from "../components/PDPForm.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as PDPTypes$Showside from "../types/PDPTypes.bs.js";
import * as Caml_js_exceptions from "../../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as Namespace$Showside from "../types/Namespace.bs.js";
import * as PDPNavbar$Showside from "../components/PDPNavbar.bs.js";
import * as PDPContent$Showside from "../components/PDPContent.bs.js";
import * as Scrollable$Showside from "../components/Scrollable.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as ErrorBoundary$Showside from "../utils/ErrorBoundary.bs.js";
import * as ErrorReporter$Showside from "../components/ErrorReporter.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as RollbarInstance$Showside from "../utils/RollbarInstance.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as LauncherApp_Lazy$Showside from "../apps/LauncherApp_Lazy.bs.js";
import * as PDPContentMobile$Showside from "../components/PDPContentMobile.bs.js";
import * as UsePDPPagination$Showside from "../hook/UsePDPPagination.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as PDPContentDesktop$Showside from "../components/PDPContentDesktop.bs.js";
import * as PDPLoadingStencils$Showside from "../components/PDPLoadingStencils.bs.js";
import * as PausePageScrolling$Showside from "../components/PausePageScrolling.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function ProductDetailsPage$PDPWrapper(Props) {
  var children = Props.children;
  var product = Props.product;
  var variant = Props.variant;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  return React.createElement(PDPForm$Showside.make, PDPForm$Showside.makeProps(product, variant, undefined, match.config.settings.hideOutOfStock, match$1.onProductFormChange, match$1.onProductFormSubmit, React.createElement(ProductDetailsContext$Showside.Provider.make, {
    product: product,
    variant: variant,
    children: children
  }), undefined, undefined));
}
ProductDetailsPage$PDPWrapper.displayName = "ProductDetailsPage.PDPWrapper";
var PDPWrapper = {
  make: ProductDetailsPage$PDPWrapper
};
function ProductDetailsPage(Props) {
  var viewport = Props.viewport;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var shouldForceMobileOpt = Props.shouldForceMobile;
  var isInsideQuickViewOpt = Props.isInsideQuickView;
  var quickViewConfig = Props.quickViewConfig;
  var productId = Props.productId;
  var showMoreProducts = Props.showMoreProducts;
  var showLauncherOpt = Props.showLauncher;
  var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
  var isInsideQuickView = isInsideQuickViewOpt !== undefined ? isInsideQuickViewOpt : false;
  var showLauncher = showLauncherOpt !== undefined ? showLauncherOpt : false;
  PausePageScrolling$Showside.usePausePageScrolling(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var account = match$1.transitiveAccount;
  var storeId = match$1.transitiveStoreId;
  var settings = match$1.settings;
  var configId = match$1.id;
  var scrollToRef = React.useRef(function (param) {});
  var fallbackScrollableContainerRef = React.useRef(null);
  var scrollableContainerRef$1 = Belt_Option.getWithDefault(scrollableContainerRef, fallbackScrollableContainerRef);
  var fallbackViewportRef = React.useRef(null);
  var viewport$1 = Belt_Option.getWithDefault(viewport, fallbackViewportRef);
  var match$2 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$2.onBackClick;
  var trackEvent = match$2.trackEvent;
  var embedType = match$2.embedType;
  var match$3 = ViewportContext$Showside.use(undefined);
  var isMobile = match$3.isMobile;
  var match$4 = UserSavedProductsProvider$Showside.use(undefined);
  var addToHistory = match$4.history.add;
  var match$5 = RouterProvider$Showside.useRouter(undefined);
  var anyVariantId = match$5.anyVariantId;
  var anyProductId = match$5.anyProductId;
  var listPageType = match$5.listPageType;
  var route = match$5.route;
  var stickyHeaderOffset = StickyHeaderOffsetProvider$Showside.useLenient(undefined);
  var productId$1;
  if (productId !== undefined) {
    productId$1 = productId;
  } else if (typeof route === "number") {
    productId$1 = anyProductId;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        productId$1 = isInsideQuickView ? anyProductId : route._0.productId;
        break;
      case /* QuickView */3:
        productId$1 = isInsideQuickView ? route._0.productId : anyProductId;
        break;
      default:
        productId$1 = anyProductId;
    }
  }
  var variantId;
  if (typeof route === "number") {
    variantId = anyVariantId;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        variantId = isInsideQuickView ? anyVariantId : route._0.variantId;
        break;
      case /* QuickView */3:
        variantId = isInsideQuickView ? route._0.variantId : anyVariantId;
        break;
      default:
        variantId = anyVariantId;
    }
  }
  var pdpCategory = UsePDPPagination$Showside.useProductCategory(match$2.smartnavApiHost, storeId, productId$1, route, !isInsideQuickView);
  React.useEffect(function () {
    if (productId$1 !== undefined && Caml_obj.notequal(listPageType, /* History */1) && Caml_obj.notequal(Category$Showside.ExternalConnection.getConnection(pdpCategory), /* History */0)) {
      Curry._1(addToHistory, {
        TAG: /* ProductId */1,
        _0: productId$1
      });
    }
  }, [productId$1]);
  var config = UsePDPPagination$Showside.usePDPPagination(quickViewConfig, pdpCategory, settings, productId$1, variantId);
  var product = React.useMemo(function () {
    return PDPTypes$Showside.getActiveProduct(config);
  }, [PDPTypes$Showside.getKey(config)]);
  var variant = React.useMemo(function () {
    return PDPTypes$Showside.getActiveVariant(config);
  }, [PDPTypes$Showside.getKey(config)]);
  React.useEffect(function () {
    if (product !== undefined) {
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
      Curry.app(trackEvent, ["product details:open", undefined, undefined, product, variant, undefined, undefined, undefined, tmp, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
  }, [Belt_Option.map(product, function (product) {
    return product.id;
  })]);
  React.useEffect(function () {
    if (product !== undefined && variant !== undefined) {
      UseTracking$Showside.trackRetargeting(account, configId, pdpCategory, product, variant, isMobile, undefined, undefined, 1, undefined, undefined, "view_item");
    }
  }, [Belt_Option.map(product, function (product) {
    return product.id;
  })]);
  var renderPDPControls = function (param) {
    var isNewMobileLayout = settings.newMobilePDP;
    var isBuiltinPDP = embedType !== /* ProductDetailsPage */5;
    var isOldDesktopLayout = !isMobile && settings.desktopPDPLayout === /* Old */0;
    var isQuickViewOldPDPMobile = isMobile && isInsideQuickView && !isNewMobileLayout;
    var isBuiltinPDPDesktop = !isMobile && isBuiltinPDP && !isInsideQuickView;
    var isBuiltinOldPDPMobile = isMobile && isBuiltinPDP && !isNewMobileLayout && !isInsideQuickView;
    var shouldRenderNavbar = isQuickViewOldPDPMobile || isBuiltinPDPDesktop || isBuiltinOldPDPMobile;
    if (shouldRenderNavbar) {
      return React.createElement(PDPNavbar$Showside.make, {
        close: isOldDesktopLayout
      });
    } else {
      return null;
    }
  };
  var renderLauncher = !isInsideQuickView && showLauncher ? function (className) {
    return React.createElement(ConfigurationProvider$Showside.make, {
      embedType: /* Launcher */2,
      configId: configId,
      children: React.createElement(LocationConfig$Showside.Provider.make, {
        namespace: Namespace$Showside.fromString("pl"),
        children: React.createElement(RouterProvider$Showside.make, {
          configId: configId,
          embedType: /* Launcher */2,
          children: React.createElement(StickyHeaderOffsetProvider$Showside.make, {
            children: React.createElement(LauncherApp_Lazy$Showside.make, {
              configId: configId,
              embedType: /* Launcher */2,
              className: className
            })
          })
        })
      }),
      enableTrimmingTreeByReferrer: false
    });
  } : undefined;
  var renderPDP = function (param) {
    var match = settings.pdpComponent;
    if (match !== undefined && product !== undefined && variant !== undefined) {
      return React.createElement(Scrollable$Showside.make, {
        children: React.createElement(NavSDK$Showside.ProductRenderer.make, {
          componentId: match.id,
          data: product,
          props: match.props,
          renderFallback: function (param) {
            return null;
          }
        })
      });
    } else {
      var match$1 = config.error;
      var match$2 = settings.newMobilePDP;
      var match$3 = settings.desktopPDPLayout;
      if (match$1 !== undefined) {
        return React.createElement(ErrorReporter$Showside.make, {
          error: RollbarInstance$Showside.makeError(true, Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(match$1), function (e) {
            return e.message;
          }), "An unexpected error occurred while loading product.")),
          extraInfo: {
            requestedStoreId: storeId,
            requestedProductId: productId$1,
            requestedVariantId: variantId,
            gotProductId: Belt_Option.map(product, function (product) {
              return product.id;
            }),
            gotVariantId: Belt_Option.map(variant, function (variant) {
              return variant.id;
            })
          },
          redirect: onBackClick,
          absolute: true
        });
      }
      if (product !== undefined && variant !== undefined) {
        var exit = 0;
        var exit$1 = 0;
        if (match$2) {
          if (isMobile) {
            var tmp = {
              product: product,
              variant: variant,
              productCategory: pdpCategory,
              config: config,
              shouldForceMobile: shouldForceMobile,
              settings: settings,
              isInsideQuickView: isInsideQuickView,
              scrollableContainerRef: scrollableContainerRef$1,
              scrollToRef: scrollToRef
            };
            if (productId$1 !== undefined) {
              tmp.routeProductId = productId$1;
            }
            if (variantId !== undefined) {
              tmp.routeVariantId = variantId;
            }
            if (showMoreProducts !== undefined) {
              tmp.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
            }
            if (renderLauncher !== undefined) {
              tmp.renderLauncher = Caml_option.valFromOption(renderLauncher);
            }
            return React.createElement(ProductDetailsPage$PDPWrapper, {
              children: React.createElement(PDPContentMobile$Showside.make, tmp),
              product: product,
              variant: variant
            });
          }
          exit$1 = 3;
        } else {
          exit$1 = 3;
        }
        if (exit$1 === 3) {
          if (match$3 !== 0 && !(isMobile || isInsideQuickView)) {
            var tmp$1 = {
              config: config,
              product: product,
              variant: variant,
              productCategory: pdpCategory,
              shouldForceMobile: shouldForceMobile,
              isInsideQuickView: isInsideQuickView,
              viewport: viewport$1,
              scrollableContainerRef: scrollableContainerRef$1,
              scrollToRef: scrollToRef
            };
            if (showMoreProducts !== undefined) {
              tmp$1.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
            }
            if (renderLauncher !== undefined) {
              tmp$1.renderLauncher = Caml_option.valFromOption(renderLauncher);
            }
            return React.createElement(ProductDetailsPage$PDPWrapper, {
              children: React.createElement(PDPContentDesktop$Showside.make, tmp$1),
              product: product,
              variant: variant
            });
          }
          exit = 2;
        }
        if (exit === 2) {
          var tmp$2 = {
            product: product,
            variant: variant,
            productCategory: pdpCategory,
            shouldForceMobile: shouldForceMobile,
            isInsideQuickView: isInsideQuickView,
            viewport: viewport$1,
            scrollableContainerRef: scrollableContainerRef$1,
            scrollToRef: scrollToRef
          };
          if (showMoreProducts !== undefined) {
            tmp$2.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
          }
          if (renderLauncher !== undefined) {
            tmp$2.renderLauncher = Caml_option.valFromOption(renderLauncher);
          }
          return React.createElement(ProductDetailsPage$PDPWrapper, {
            children: React.createElement(PDPContent$Showside.make, tmp$2),
            product: product,
            variant: variant
          });
        }
      }
      return React.createElement(PDPLoadingStencils$Showside.make, {
        productId: productId$1,
        variantId: variantId,
        isInsideQuickView: isInsideQuickView
      });
    }
  };
  var fixedPositionPDP = embedType !== 0 ? !isInsideQuickView : false;
  var zIndex = embedType >= 5 ? "0" : settings.zIndex;
  return React.createElement(ErrorBoundary$Showside.make, {
    componentName: "PDP",
    redirect: onBackClick,
    children: React.createElement(ReactIf.If, {
      condition: fixedPositionPDP,
      children: null
    }, React.createElement(ReactIf.Then, {
      children: React.createElement(BaseWithTheme$Showside.make, {
        initiator: "pdp",
        portal: true,
        children: React.createElement("div", {
          ref: ReactDOMUtils$Showside.Ref.domRef(fallbackViewportRef),
          className: CSS$Showside.prefix("fixed left-0 w-full bg-main text-primary overflow-hidden select-none touch-none clip-path-bottom-xl"),
          style: {
            height: stickyHeaderOffset > 0 ? "calc(100% - " + CSS$Showside.intToPx(stickyHeaderOffset) + ")" : "100%",
            top: CSS$Showside.intToPx(stickyHeaderOffset),
            zIndex: zIndex,
            transform: "translate3d(0,0,0)"
          }
        }, renderPDPControls(undefined), renderPDP(undefined))
      })
    }), React.createElement(ReactIf.Else, {
      children: null
    }, renderPDPControls(undefined), renderPDP(undefined)))
  });
}
ProductDetailsPage.displayName = "ProductDetailsPage";
var make = ProductDetailsPage;
var $$default = ProductDetailsPage;
export { PDPWrapper, make, $$default, $$default as default };
/* react Not a pure module */